/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colour encodes magnitude on a continuous scale from the minimum to the maximum value in your data. The legend shows exactly which value each colour represents.`)
};

const es_heat_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El color codifica la magnitud en una escala continua desde el valor mínimo hasta el máximo de tus datos. La leyenda muestra exactamente qué valor representa cada color.`)
};

const de_heat_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe kodiert die Größenordnung auf einer stetigen Skala vom Minimal- bis zum Maximalwert Ihrer Daten. Die Legende zeigt genau, welchen Wert jede Farbe darstellt.`)
};

const nl_heat_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleur codeert grootte op een continue schaal van de minimum- tot de maximumwaarde in je data. De legenda toont precies welke waarde elke kleur vertegenwoordigt.`)
};

const fr_heat_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La couleur encode l'ampleur sur une échelle continue du minimum au maximum de vos données. La légende montre exactement quelle valeur chaque couleur représente.`)
};

const it_heat_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il colore codifica la grandezza su una scala continua dal valore minimo al massimo dei tuoi dati. La legenda mostra esattamente quale valore rappresenta ciascun colore.`)
};

const pt_br2_heat_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cor codifica a magnitude em uma escala contínua do valor mínimo ao máximo dos seus dados. A legenda mostra exatamente qual valor cada cor representa.`)
};

const pt_heat_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cor codifica a magnitude numa escala contínua do valor mínimo ao máximo nos seus dados. A legenda mostra exatamente qual o valor que cada cor representa.`)
};

const ja_heat_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色は、データ中の最小値から最大値までの連続スケールで大きさを表します。凡例には各色がどの値を表すか正確に示されます。`)
};

const zh_heat_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`颜色在你数据的最小值到最大值之间以连续刻度编码数值大小。图例会精确显示每种颜色对应的数值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_faq_a2", locale)
	if (locale === "en") return en_heat_faq_a2(inputs)
	if (locale === "es") return es_heat_faq_a2(inputs)
	if (locale === "de") return de_heat_faq_a2(inputs)
	if (locale === "nl") return nl_heat_faq_a2(inputs)
	if (locale === "fr") return fr_heat_faq_a2(inputs)
	if (locale === "it") return it_heat_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_heat_faq_a2(inputs)
	if (locale === "pt") return pt_heat_faq_a2(inputs)
	if (locale === "ja") return ja_heat_faq_a2(inputs)
	return zh_heat_faq_a2(inputs)
};